

// 引入公共文件
import { formCheck } from '../../../assets/js/xjpublic'
import { errorModal } from '../../../assets/js/xjcommon';

import { Cell, CellGroup, Switch, Slider, RadioGroup, Radio, Popup, Field, TreeSelect, Picker } from 'vant'

export default {
  name: 'home',
  components: {
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Switch.name]: Switch,
    [Slider.name]: Slider,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [Popup.name]: Popup,
    [Field.name]: Field,
    [TreeSelect.name]: TreeSelect,
    [Picker.name]: Picker
  },
  data () {
    return {
      // 当前IMEI
      nowImei: $cookies.get('imei'),
      // 车辆信息数据
      bdNickNameSet: '',
      bdCarType: '',
      bdCarBrandAndModel: '',
      bdCarLicense: '',
      // part2 设置信息数据
      // 最初返回的数据(用户更新提交前对比)
      settingsAll: {},
      // 是否开启震动报警
      checkedAlarmShake: false,
      // 是否开启行程报告
      checkedTravelNotify: false,
      // 是否开启停车报告
      checkedParkingNotify: false,
      // 停车报告是拍照还是拍视频,1:拍照,2:录像
      checkedParkingNotifyType: '',
      // 是否分享地理位置
      checkedSharePosition: false,
      // 是否分享到境界
      checkedShareAutocloud: false,
      // 是否锁定后视镜
      checkedDeviceLocked: false,
      // 是否开启震动视频自动上传
      checkedAlarmShakeVedio: false,
      // 是否开启休眠防盗视频锁定
      checkedAlarmAccoff: false,
      // 休眠震动报警是拍照还是录像,1:拍照,2:录像
      checkedAlarmAccoffType: '',
      // part 3
      // 震动级别,震动灵敏度
      shockValue: 30,
      // 星空流媒体时长
      // 用户已经设置的值(用于后面对比)
      radioValueBefore: '15',
      // 用户选择的值
      radioValue: '15',
      // 星空流媒体时长
      maxTime: 15,
      // frontTimeValue为前视频时长,后视频通过maxTime-frontTimeValue得到
      frontTimeValueBefore: 8,
      frontTimeValue: 8,
      // 是否显示更新设备设置按钮vehicle
      showVehicleBtn: false,
      // 选择汽车类型
      showActionSheetCarType: false,
      carTypeList: [
        { name: '小汽车' },
        { name: '大客车' },
        { name: '小货车' },
        { name: '大货车' },
        { name: '电动车' },
      ],
      // 设置昵称
      showPopupSetNickName: false,
      bdNickName: '',
      // 设置车牌号码
      showPopupCarLicense: false,
      showPopupCarPlace: false,
      bdCarPlace: '',
      bdCarNumber: '',
      columnsCarPlace: ['京', '沪', '浙', '苏', '粤', '鲁', '晋', '冀', '豫', '川', '渝', '辽', '吉', '黑', '皖', '鄂', '湘', '赣', '闽', '陕', '甘', '宁', '蒙', '津', '贵', '云', '桂', '琼', '青', '新', '藏'],
      // 选择汽车品牌
      carBrand: '',
      carModel: '',
      carIcon: '',
      showPopupCarBrand: false,
      itemsCarBrand: [],
      // 左侧高亮元素的index
      mainActiveIndex: 0,
      // 被选中元素的id
      activeId: 1,
      settingItem:[],
      specItemType:["space","1","2"], //后台云服务设置,通知中心
    }
  },
  methods: {
    // 获取车辆信息
    initCarInfoFn () {
      let _this = this;
      this.$toast.loading({
        overlay: true,
        duration: 0,
        message: '加载中...'
      });
      this.$axios.post('/v3/u/vehicle/GetCarInfoByImei')
        .then((response)=>{
          this.$toast.clear();
          const data =response.data
          if (data.ret === 0) {
            // part1
            this.nowImei = this.$cookies.get('imei');
            this.bdNickNameSet = data.data.nick_name;
            this.bdCarType = data.data.car_type;
            this.activeId = data.data.series_id;
            this.bdCarBrandAndModel = data.data.car_brand ? (data.data.car_brand === '其他' ? '其他' : (data.data.car_brand + ' ' + data.data.car_model)) : '';
            this.carModel = data.data.car_model,
            this.carBrand = data.data.car_brand,
            this.bdCarLicense = data.data.car_license;
            this.bdCarPlace = data.data.car_license ? data.data.car_license.substring(0, 1) : '';
            this.bdCarNumber = data.data.car_license ? data.data.car_license.substring(1) : '';

            this.getAllCarBrand()

          } else {
            _this.$dialog({
              message: response.data.msg ? response.data.msg + '（' + response.data.ret + '）' : '获取设备信息失败（' + response.data.ret + '）'
            })
          }
        })
        .catch(function (error) {
          _this.$toast.clear();
          errorModal(error, 161);
        })
    },
    // 获取设备信息
    initDevInfoFn () {
      this.$toast.loading({
        overlay: true,
        duration: 0,
        message: '加载中...'
      });

      Promise.all([  this.$axios.post('/v3/u/setting/getTemplate'),this.$axios.post('/v3/u/setting/queryBackendSetting')]).then(res=>{

        const template = res[0].data.data.template;
        const errorReason = res[0].data.data.reason;
        const mergeItemList = res[1].data.data;

        const mergeSetting = this.unification(template,mergeItemList,errorReason);
        const filter = mergeSetting.filter(item=>!item.isDisabled).reverse().map(item=>item.itemList).flat(2).filter(item=>item.show && item.cmd!=="voice")
        this.settingItem =filter;
      }).catch((error)=>{
          this.$toast.clear();
          errorModal(error, 161);
        })
    },
     // 通过模板数据去匹配对应的后台和设备 item
    unification(filterTemplate,mergeItemList,errorReason){
        const isAuthService = true;
        const specItemType = this.specItemType;
        return filterTemplate.map((item,index)=>{
          const id = item.type ==="space" ? "space":item.c
          const itemList = (item.itemList||[]).map(inItem=>{
          const matchItem =  mergeItemList.find(mItem=>mItem.c === inItem.c)||{}

            return{
              ...inItem,
              ...matchItem,
              show:!!matchItem.c ? true :false,
            }
          })
          // 所有匹配到的子项都是0 则获取子项errorcode  然后排序-获取最小值，通过reasonTemplet，得到对应的tips，进行提示
          const isDisabled = itemList.filter(i=>i.show).every(item=>item.s === "0");
          const errorCode = Math.min(...itemList.map(item=>Number(item.r)).sort((a,b)=>a-b))
          const findCorErrReason = errorReason.find(item=>item.r == errorCode);
          const reasonTips =findCorErrReason||(isAuthService?{}:{msg:"设备不支持该服务",type:"toast"});
          return {
            ...item,
            c:id,
            itemList,
            isDisabled: specItemType.includes(id) ? false : isDisabled,
            reasonTips,
            folderShow: specItemType.includes(id) ? true : !!item.folderShow,
          }
      })
    },
    // 选择IMEI
    selectImeiFn () {
      this.showActionSheetImei = true
    },
    // 更新车辆信息
    updateCarInfoFn () {
      let _this = this;
      if(this.carBrand==""){
        this.$dialog({
          message: "请选择汽车品牌"
        })
        return;
      }else if(this.carModel==""){
        this.$dialog({
          message: "请选择车辆类型"
        })
        return;
      }
    this.$toast({
      mask: true,
      duration: 0,
      message: '更新中...'
    });
      this.$axios.post('/v3/u/vehicle/setCarInfo', {
        nickname: this.bdNickNameSet,
        series_id: this.activeId,
        car_brand:  this.carBrand,
        car_model: this.carModel,
        car_icon:  this.bdCarIcon,
        car_license: this.bdCarLicense,
      })
        .then(function (response) {
          // console.log(response);
          _this.$toast.clear();
          if (response.data.ret === 0) {
            _this.$toast({
              message: '更新成功'
            })
          } else {
            _this.$dialog({
              message: response.data.msg ? response.data.msg + '（' + response.data.ret + '）' : '更新失败（' + response.data.ret + '）'
            })
          }
        })
        .catch(function (error) {
          _this.$toast.clear();
          errorModal(error, 162);
        })
    },

    // 获取星空流媒体视频总时长
    onChangeMaxTimeFn (e) {
      this.maxTime = parseInt(e);
      // 选择总的选择是5,10,15
      if (parseInt(e) === 15 && parseInt(this.radioValueBefore) !== 15) {
        this.frontTimeValue = 8
      } else if (parseInt(e) === 10 && parseInt(this.radioValueBefore) !== 10) {
        this.frontTimeValue = 5
      } else if (parseInt(e) === 5 && parseInt(this.radioValueBefore) !== 5) {
        this.frontTimeValue = 3
      } else {
        this.frontTimeValue = this.frontTimeValueBefore;
      }
      // 之前可选择是15,30,45
      // if (parseInt(e) === 15 && parseInt(this.radioValueBefore) !== 15) {
      //   this.frontTimeValue = 8
      // } else if (parseInt(e) === 30 && parseInt(this.radioValueBefore) !== 30) {
      //   this.frontTimeValue = 15
      // } else if (parseInt(e) === 45 && parseInt(this.radioValueBefore) !== 45) {
      //   this.frontTimeValue = 25
      // } else {
      //   this.frontTimeValue = this.frontTimeValueBefore;
      // }
    },
    // 获取星空流媒体前视频时长
    onChangeMediaTimeFn (e) {
      this.frontTimeValue = e
    },
    // 选择汽车品牌
    selectCarBrandFn () {
      this.showPopupCarBrand = true
    },
    onClickNav (index) {
      this.mainActiveIndex = index;
      const childrenID = this.itemsCarBrand[index];
      this.bdCarIcon = childrenID.icon;
      this.carIcon = childrenID.icon;
      this.carBrand = childrenID.text;
      this.activeId = 0;
      this.getCarBrandChild(childrenID.id)
    },
    onClickItem (data) {
      this.carIcon = data.icon;
      this.carModel = data.text;
      this.activeId = data.id;
      this.bdCarBrandAndModel = this.carBrand === '其他' ? '其他' : this.carBrand + ' ' + data.text;
      setTimeout(()=>{
        this.showPopupCarBrand = false
      }, 100)
    },
    // 选择汽车类型
    selectCarTypeFn () {
      this.showActionSheetCarType = true;
    },
    onSelectCarTypeFn (item) {
      this.bdCarType = item.name;
      this.showActionSheetCarType = false;
    },
    // 设置昵称
    setNickNameFn () {
      this.bdNickName = this.bdNickNameSet;
      this.showPopupSetNickName = true;
    },
    setNickNameSubmitFn () {
      if (!this.bdNickName) {
        this.$toast('昵称不能为空');
        return
      }
      if (this.bdNickName.length > 8) {
        this.$toast('不能超过8个字');
        return
      }
      this.bdNickNameSet = this.bdNickName;
      this.showPopupSetNickName = false;
    },
    // 设置车牌号码
    setCarLicenseFn () {
      this.showPopupCarLicense = true;
    },
    closePopupFn () {
      this.showPopupSetNickName = false;
      this.showPopupCarLicense = false;
    },
    selectCarPlaceFn () {
      this.showPopupCarPlace = true;
    },
    onConfirm (value, index) {
      this.bdCarPlace = value;
      this.showPopupCarPlace = false;
    },
    onCancel () {
      this.showPopupCarPlace = false;
    },
    setCarLicenseSubmitFn () {
      if (!this.bdCarPlace) {
        this.$toast('请选择归属地');
        return
      }
      if (!this.bdCarNumber) {
        this.$toast('请将车牌号码填写完整');
        return
      }
      if (!formCheck.checkLicense(this.bdCarPlace + this.bdCarNumber)) {
        this.$toast('车牌号码错误');
        return
      }
      this.bdCarLicense = this.bdCarPlace + this.bdCarNumber;
      this.showPopupCarLicense = false
    },

    boolChange(value,cmd){
      this.updateDevInfoFn({key:cmd,value})
    },
    radioGroupChange(value,cmd){
      this.updateDevInfoFn({key:cmd,value})
    },
    sliderValueUpdate(cmd,value){
      this.updateSettingItemValue(cmd,value)
    },
    sliderChange(value,cmd){
      this.updateDevInfoFn({key:cmd,value})
    },
    updateSettingItemValue(cmd,value){
      this.settingItem = this.settingItem.map(item=>({...item,v:item.cmd===cmd?value:item.v}))
    },

    // 更新设置
    updateDevInfoFn (reqData) {
      this.$toast.loading({
        overlay: true,
        duration: 0,
        message: '更新中...'
      });

      this.$axios.post('/v3/u/setting/setBackendSettings', {[reqData.key]:reqData.value}).then( (response)=>{
          this.$toast.clear();
          if (response.data.ret === 0) {
            this.$toast({
              message: '更新成功'
            })
            this.updateSettingItemValue(reqData.key,reqData.value)
          } else {
            this.$dialog({
              message: response.data.msg ? response.data.msg + '（' + response.data.ret + '）' : '更新失败（' + response.data.ret + '）'
            })
          }
        })
        .catch((error)=>{
          this.$toast.clear();
          errorModal(error, 163);
        })
    },
    getAllCarBrand () {
      this.$axios.post('/v3/u/carBrand/allBrand', {}).then(res=>{
        const data = res.data.data;
        this.itemsCarBrand = data.map(item=>({text:item.brand_name,id:item.brand_id,children:[],icon:item.brand_img}));

        this.mainActiveIndex = this.itemsCarBrand.findIndex((item)=>item.text === this.carBrand);
        this.carBrand = this.itemsCarBrand[this.mainActiveIndex].text;
        this.carIcon = this.itemsCarBrand[this.mainActiveIndex].icon;
        this.bdCarIcon = this.carIcon;
        this.getCarBrandChild(this.itemsCarBrand[this.mainActiveIndex].id)
      })
    },
    getCarBrandChild(b_id){
      this.$axios.post('/v3/u/carBrand/searchBrandType', {brand_id: b_id}).then(res=>{
        const children = res.data.data;
        const formChildren = (children||[]).map(item=>({text:item.name,id:item.series_id}));
        this.itemsCarBrand = this.itemsCarBrand.map(item=>{
          return {
            ...item,
            children:item.id === b_id?formChildren:item.children||[]
          }
        })
      })

    },
    // 切换设备
    toChangeDevPageFn () {
      this.$router.push('/changeDev')
    }
  },
  created () {
    window.scrollTo(0,0);
    // this.itemsCarBrand = carInfo;
    // this.carBrand = carInfo[0].text;
    // this.carModel = carInfo[0].children[0].text;
    // this.carIcon = carInfo[0].children[0].icon;
    this.bdCarBrandAndModel = this.carBrand === '其他' ? '其他' : this.carBrand + ' ' + this.carModel;
    this.initCarInfoFn();
    this.initDevInfoFn();
  }
}
